import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 mb-4">
            <i className="ri-question-answer-line text-secondary-600 text-sm"></i>
            <span className="text-secondary-700 text-xs font-medium">常见问题</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            关于每日黑料，你可能想了解的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 list-none marker:content-none">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 pr-4 group-open:text-primary-600 transition-colors">
                  {item.question}
                </h3>
                <div className="w-7 h-7 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0 transition-all group-open:bg-primary-500">
                  <i className="ri-add-line text-secondary-600 text-sm group-open:text-background-50 transition-all group-open:rotate-45"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}